Browser = require 'lib/browser'
f = require 'effing'
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list_item')
track = require 'debug/track'
Dotdotdot = require 'react-dotdotdot'

isSafariLeftClick = (e) ->
  browser = Browser.browserStr
  browser == 'safari' && e.button == 0

module.exports = class extends React.Component
  displayName: 'BoardListItemComponent'
  render: t.renderable ->
    { isStarred, background: { color, image, tiled, brightness }, relUrl,
    orgname, name, showOptions, id, onStarClick, badgeComponents, tagComponents,
    hidden, hasUnseenActivity, isDraggable, onBoardClick } = @props

    backgroundStyle = @getBackgroundStyle()

    t.li class: t.classify(hide: hidden, 'boards-page-board-section-list-item': true, 'js-draggable': isDraggable), ->

      classes =
        'board-tile': true
        tile: tiled

      if !color
        switch brightness
          when "unknown"
            classes["mod-unknown-background"] = true
          when "light"
            classes["mod-light-background"] = true

      # onMouseDown and onMouseUp are here to prevent
      # Safari's default rendering <a> tags while they're
      # being dragged, which changes them to a gray box
      # containing the href attribute. The author of
      # React-DND has said this cannot be fixed, as it is
      # how Safari implements HTML5. The logic of our
      # workaround, then, is this:
      # If the <a> tag doesn't have an href attr, the image
      # will not change while being dragged. However, we do
      # need each board tile to have an href attr on right-click.
      # So, in non-Safari browsers, we do nothing onMouseDown, but
      # in Safari, if we detect a left click (which may lead into a
      # drag), we remove the href onMouseDown and reset it
      # onMouseUp, which occurs before the click. Dragging, plus
      # left/right click navigation, works everywhere -- and in Safari.
      onMouseDown = (e) ->
        if isSafariLeftClick(e)
          boardTileLink = e.currentTarget
          boardTileLink.removeAttribute('href')
      onMouseUp = (e) ->
        boardTileLink = e.currentTarget
        boardTileLink.setAttribute('href', relUrl)

      onClick = onBoardClick
      t.link relUrl, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, class: t.classify(classes), style: backgroundStyle, ->
        t.span '.board-tile-fade'

        detailClasses =
          'board-tile-details': true,
          'is-badged': true,
          'is-sub-named': orgname

        t.div class: t.classify(detailClasses), ->
          t.div '.board-tile-details-name', { title: name, dir: 'auto' }, ->
            t.tag Dotdotdot, { clamp: 2 }, ->
              t.text name

          t.div '.board-tile-details-sub-container', ->
            if orgname
              t.span '.board-tile-details-sub-name', { title: orgname, dir: 'auto' }, ->
                t.text orgname

            if showOptions
              t.span '.board-tile-options', ->
                if hasUnseenActivity
                  t.span '.board-tile-options-unread-indicator', { title: t.l('there-is-new-activity-on-this-board') }
                t.icon 'star',
                  class: t.classify('is-starred': isStarred, 'board-tile-options-star-icon': true)
                  title: t.l('click-to-star-this-board-it-will-show-up-at-top-of-your-boards-list')
                  onClick: (e) ->
                    e.preventDefault()
                    e.stopPropagation()
                    onStarClick(id)

        t.span '.board-tile-badges', ->
          badgeComponents.forEach f(t, 'addElement')

      t.div '.board-tags.u-clearfix', ->
        tagComponents.forEach f(t, 'addElement')

  getBackgroundStyle: =>
    { background: { color, image, tiled, brightness } } = @props

    if color
      backgroundColor: color
    else
      backgroundImage: t.urlify image

  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-component.coffee